module.exports = __webpack_public_path__ + "static/img/Gacha04.266ba51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha04.png
// module id = w09H
// module chunks = 1